import { css, keyframes } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';

const { colors, spacing, borderRadius, typography } = tokens;

const STAGGER_MS = 100;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const row = css`
  display: flex;
  gap: ${spacing.s};
`;

export const tile = (index: number) => css`
  flex: 1;
  padding: ${spacing.m};
  border-radius: ${borderRadius.outer};
  background-color: ${colors.neutral.subdued.default};
  animation: ${fadeIn} 500ms ease-out both;
  animation-delay: ${index * STAGGER_MS}ms;

  @media (prefers-reduced-motion) {
    animation: none;
  }
`;

export const value = css`
  ${applyFont(typography.displayMedium)}
  color: ${colors.neutral.heavy.default};
`;

export const label = css`
  ${applyFont(typography.mini)}
  color: ${colors.neutral.medium.default};
`;

export const caveat = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
  margin: ${spacing.m} 0 0;
`;
